export const MIN_PASSWORD_LENGTH = 12,
    MAX_PASSWORD_LENGTH = 128;
